import { Injectable } from '@angular/core';

import { Observable, from } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { HttpClient, HttpHeaders }  from "@angular/common/http";

import apiconfig from '../apiconfig';


@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private http: HttpClient
  ) { }

  public createReport(idToken, typeOp, username, date, faceId, mod, rounding): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    return from(
      this.http.post(apiconfig.endpoint + "/facegatereport",{ 'typeOp': typeOp, 'user' : username, 'time' : date, 'faceId' : faceId, 'modCheck' : mod, 'rounding' : rounding },httpOptions),
    ).pipe(
      tap(() => console.log("createReportdata"))
    );

  }



}
